export default {"src":"/_next/static/media/dewi_loading.236b232e.gif","height":400,"width":400,"blurWidth":0,"blurHeight":0};